import { render, staticRenderFns } from "./products.vue?vue&type=template&id=32e2bf8c&scoped=true&"
import script from "./products.vue?vue&type=script&lang=ts&"
export * from "./products.vue?vue&type=script&lang=ts&"
import style0 from "./products.vue?vue&type=style&index=0&id=32e2bf8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2bf8c",
  null
  
)

export default component.exports